<ui-subheader [subheader]="flowType">
    <div class="cross-icon-button" (click)="checkRequestChanges()">
        <i class="icon-cross_16px"></i>
    </div>
</ui-subheader>
<ui-stepper class="employee-badge-request-block"
            [doStepSubject]="doStepSubject"
            (onActiveSectionChange)="onActiveSectionChange($event);"
            [activeSection]="0">
    <ng-template stepperSection
                 [title]="'Request details'"
                 [icon]="'icon-tiles'">
        <employee-request-details
            [requestData]="requestData"
            [requestReasonPayload]="requestReasonPayload"
            [isPPMD] = "isPPMD"
            (onRequestReasonSelect)="checkValidNextStep($event)"
            (onPPMDUserSelected)="pPMDUserSelected($event)">
        </employee-request-details>
    </ng-template>

    <ng-template stepperSection
                 [title]="'Take photo'"
                 [icon]="'icon-photo-camera'">
        <employee-take-photo
            [userCanTakePhoto]="isUserCanTakePhoto"
            [newFileName]="newFileName"
            [canUseCurrentImage]="canUseCurrentImage"
            [userPhotoUrl]="userPhotoUrl"
            [photoData]="userPhotoData"
            [requestData]="requestData"
            [isVisitorRequest]="isVisitorRequest"
            (onUpload)="uploadAction($event)"
            (onUseCurrentPhoto)="useCurrentPhotoAction($event)"
            (onDelete)="deleteAction()">
        </employee-take-photo>
    </ng-template>

</ui-stepper>

<div class="controls">
    <div class="container_">
        <button *ngIf="isShowBackBtn" class="back button text with-icon" (click)="back()">
            <i class="icon-left"></i>
            Back
        </button>
        <button *ngIf="isShowNextBtn" class="next button primary" [disabled]="!canOpenTakePhotoStepper" (click)="openTakePhotoStepper()">Next</button>
        <button *ngIf="!isShowNextBtn" [disabled]="!isShowSubmitBtn || !isCanSubmit" class="next button primary" (click)="submit()">Submit</button>
        <button class="next button secondary" (click)="checkRequestChanges()">Cancel</button>
        <div class="clearfix"></div>
    </div>
</div>
